import classNames from 'classnames';
import React from 'react';
import { Color } from '../enums/Color.enum';
import ColorSwatch from '../product_detail/components/ColorSwatch';
import { ifEnter } from '../util';
import styles from './BundleColorSwatch.module.scss';

export const BundleColorSwatch: React.FC<{
  title: string;
  colors: Color[];
  selected: boolean;
  setSelectedSwatch: (swatchName: string) => void;
}> = ({ title, colors, selected, setSelectedSwatch }) => {
  return (
    <div
      role="button"
      tabIndex={0}
      className={classNames(styles.buttonContainer, { [styles.selected]: !!selected })}
      onClick={() => setSelectedSwatch(title)}
      onKeyPress={(e) => ifEnter(e, () => setSelectedSwatch(title))}
      aria-label={title}
    >
      {colors.map((c, i) => {
        return (
          <ColorSwatch hideWhiteBorder={true} key={`${c}_${i}`} color={c} active={false} activate={() => undefined} showSmall={true} slim={colors.length > 4} />
        );
      })}
    </div>
  );
};

export default BundleColorSwatch;
